import React from "react"

export function dateBetweenFilter(rows, id, filterValues) {
  const startDate = filterValues[0] ? new Date(filterValues[0]) : undefined
  const endDate = filterValues[1] ? new Date(filterValues[1]) : undefined

  if (endDate || startDate) {
    return rows.filter((r) => {
      const cellDate = new Date(r.values[id])

      if (endDate && startDate) {
        return cellDate >= startDate && cellDate <= endDate
      } else if (startDate) {
        return cellDate >= startDate
      } else if (endDate) {
        return cellDate <= endDate
      }
    })
  } else {
    return rows
  }
}

dateBetweenFilter.autoRemove = (val) => !val

export default function DateRangeColumnFilter({ column: { filterValue = [], preFilteredRows, setFilter, id } }) {
  const [min, max] = React.useMemo(() => {
    let min = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)
    let max = preFilteredRows.length ? new Date(preFilteredRows[0].values[id]) : new Date(0)

    preFilteredRows.forEach((row) => {
      const rowDate = new Date(row.values[id])
      min = rowDate <= min ? rowDate : min
      max = rowDate >= max ? rowDate : max
    })

    return [min, max]
  }, [id, preFilteredRows])

  return (
    <div>
      <input
        min={min.toISOString().slice(0, 10)}
        onChange={(e) => {
          const val = e.target.value
          setFilter((old = []) => [val ? val : undefined, old[1]])
        }}
        type="date"
        value={filterValue[0] || ""}
      />
      {" to "}
      <input
        max={max.toISOString().slice(0, 10)}
        onChange={(e) => {
          const val = e.target.value
          setFilter((old = []) => [old[0], val ? val.concat("T23:59:59.999Z") : undefined])
        }}
        type="date"
        value={filterValue[1]?.slice(0, 10) || ""}
      />
    </div>
  )
}
